/**
 * RFC 9457 "problem details" — the error shape every QMED API endpoint returns
 * (huma's default), plus our machine-readable `code` extension
 * (e.g. "auth.invalid_credentials"). UIs switch on `code`, never on `detail` text.
 */
export interface ProblemDetails {
  status: number
  title?: string
  detail?: string
  type?: string
  code?: string
  /** Details of the error; `value` is the offending value when the server names it (e.g. `desk.department_uncovered` lists the department ids). */
  errors?: { message: string; location?: string; value?: unknown }[]
}

export class ApiError extends Error {
  readonly problem: ProblemDetails

  constructor(problem: ProblemDetails) {
    super(problem.detail ?? problem.title ?? `HTTP ${problem.status}`)
    this.name = "ApiError"
    this.problem = problem
  }

  get status(): number {
    return this.problem.status
  }

  get code(): string | undefined {
    return this.problem.code
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError
}

/** Network failures (offline, DNS, server down) — distinct from HTTP errors. */
export class NetworkError extends Error {
  constructor(cause: unknown) {
    super("Network request failed", { cause })
    this.name = "NetworkError"
  }
}
